export const URL = 'clubs/bookings';
